import Vue from "vue";
import axios from 'axios';
import store from "@/store";
import VueCookie from 'vue-cookie';
import VueFlashMessage from 'vue-flash-message';
import { pick } from 'lodash';
import status from 'http-status';

// Vue.use(VueCookie);
// Vue.use(VueFlashMessage);

export const http = axios.create();

http.interceptors.response.use((response) => {
  console.log('main.js response', response);
  if (response.headers['access-token']) {
    const authHeaders = pick(response.headers, ["access-token","client","expiry","uid","token-type"]);
    store.commit('auth', authHeaders);
    VueCookie.set('authHeaders', JSON.stringify(authHeaders), { expires: '14D' });
  }

  return response;
}, (error) => {
  const response = error.response;
  console.log('main.js response error.response.status UNAUTHORIZED', response.status === status.UNAUTHORIZED);
  if (!store.state.showSignIn && response.status === status.UNAUTHORIZED) {
    store.commit('currentUser', null)
    store.commit('auth', null)
    VueCookie.delete('authHeaders');
    Vue.prototype.$flashStorage.flash('Ошибка авторизации', 'error');
  } else if (response.headers['access-token']) {
    const authHeaders = pick(response.headers, ["access-token","client","expiry","uid","token-type"]);
    store.commit('auth', authHeaders);
    VueCookie.set('authHeaders', JSON.stringify(authHeaders), { expires: '14D' });
  }

  return Promise.reject(error);
});

http.interceptors.request.use(config => {
  const headers = store.getters['auth'];
  console.log('$http request headers', headers);
  console.log('$http request config', config);

  config.headers = headers;
  return config;
});

